import React, { Component } from 'react';
import { Collapse } from 'reactstrap';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { renderIcon, toggleIcon } from '../../../shared/components/icons';
import { withRouter } from 'react-router-dom';

class SidebarCategory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            collapse: this.shouldExpand(props.location.pathname, props.title),
        };
    }

    shouldExpand = (pathname: string, title: string) => {
        const lowerCaseTitle = title?.toLowerCase();
        return pathname.includes(lowerCaseTitle);
    };

    toggle = () => {
        this.setState((prevState) => ({ collapse: !prevState.collapse }));
    };

    componentDidUpdate(prevProps) {
        const { title, location } = this.props;
        const { pathname } = location;
        const previousPathname = prevProps.location.pathname;

        // Special handling for Fund Requests
        const isFundRequests = ['requests', 'payees'].some((p) =>
            pathname.includes(p)
        );
        if (previousPathname !== pathname) {
            if (isFundRequests && title === 'Requests') {
                this.setState({ collapse: true });
            } else {
                this.setState({
                    collapse: this.shouldExpand(pathname, title),
                });
            }
        }
    }

    render() {
        const { title, icon, isNew, children, style } = this.props;
        const { collapse } = this.state;
        const categoryClass = classNames({
            'sidebar__category-wrap': true,
            'sidebar__category-wrap--open': collapse,
        });

        return (
            <div className={`pb-1 ${categoryClass}`}>
                <button
                    type='button'
                    className='sidebar__link sidebar__category'
                    onClick={this.toggle}
                    style={style}
                >
                    <span className='sidebar__link-icon'>
                        {renderIcon(icon)}
                    </span>
                    <p className='sidebar__link-title'>
                        {title}
                        {isNew && <span className='sidebar__category-new' />}
                    </p>
                    <span className='sidebar__category-icon lnr lnr-chevron-right'>
                        {toggleIcon(this.state.collapse)}
                    </span>
                </button>
                <Collapse isOpen={collapse} className='sidebar__submenu-wrap'>
                    <ul className='sidebar__submenu'>
                        <div>{children}</div>
                    </ul>
                </Collapse>
            </div>
        );
    }
}

export default withRouter(SidebarCategory);
